import adminApiFetch from './apiService';

const brandService = {
  // 獲取品牌列表（用於表格）
  getRecords: async (params = {}) => {
    const res = await adminApiFetch('brands/get_records', {
      method: 'POST',
      body: params
    });
    return res.json();
  },

  // 獲取所有品牌 ID（用於篩選）
  getIds: async (params = {}) => {
    const res = await adminApiFetch('brands/get_ids', {
      method: 'POST',
      body: params
    });
    return res.json();
  },

  // 獲取品牌列表（用於下拉選單）
  fetchList: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.since_id) queryParams.append('since_id', params.since_id);
    if (params.page_size) queryParams.append('page_size', params.page_size);
    if (params.search) queryParams.append('search', params.search);

    const res = await adminApiFetch(`brands?${queryParams.toString()}`, {
      method: 'GET'
    });
    return res.json();
  },

  // 獲取單個品牌

  // 獲取單個品牌
  get: async (id) => {
    const res = await adminApiFetch(`brands/${id}`, {
      method: 'GET'
    });
    return res.json();
  },

  // 創建品牌
  create: async (data) => {
    const res = await adminApiFetch('brands', {
      method: 'POST',
      body: { brand: data }
    });
    return res.json();
  },

  // 更新品牌
  update: async (id, data) => {
    const res = await adminApiFetch(`brands/${id}`, {
      method: 'PUT',
      body: { brand: data }
    });
    return res.json();
  },

  // 刪除品牌
  delete: async (id) => {
    const res = await adminApiFetch(`brands/${id}`, {
      method: 'DELETE'
    });
    return res.json();
  }
};

export { brandService };
export default brandService;
